const getAssetUrl = md5ext => `https://cdn.assets.scratch.mit.edu/internalapi/asset/${md5ext}/get/`;

const getAssetTypeFromExtension = (storage, extension) => {
    const normalizedExtension = extension.toLowerCase();
    if (normalizedExtension === 'svg') {
        return storage.AssetType.ImageVector;
    }
    if (normalizedExtension === 'png' || normalizedExtension === 'jpg' || normalizedExtension === 'jpeg' ||
        normalizedExtension === 'bmp' || normalizedExtension === 'gif') {
        return storage.AssetType.ImageBitmap;
    }
    if (normalizedExtension === 'wav' || normalizedExtension === 'mp3') {
        return storage.AssetType.Sound;
    }
    throw new Error(`Ukendt asset-type for filtypen .${normalizedExtension}`);
};

const getDataFormatFromExtension = (storage, extension) => {
    const normalizedExtension = extension.toLowerCase();
    if (normalizedExtension === 'jpeg') {
        return storage.DataFormat.JPG;
    }
    const dataFormat = storage.DataFormat[normalizedExtension.toUpperCase()];
    if (!dataFormat) {
        throw new Error(`Ukendt dataformat for filtypen .${normalizedExtension}`);
    }
    return dataFormat;
};

const cacheAsset = async (storage, md5ext) => {
    const [assetId, extension] = md5ext.split('.');
    if (!assetId || !extension) {
        throw new Error(`Ugyldigt asset-navn: ${md5ext}`);
    }

    if (storage.get(assetId)) {
        return;
    }

    const response = await fetch(getAssetUrl(md5ext), {mode: 'cors'});
    if (!response.ok) {
        throw new Error(`Kunne ikke hente ${md5ext} (${response.status})`);
    }

    const buffer = await response.arrayBuffer();
    const assetType = getAssetTypeFromExtension(storage, extension);
    const dataFormat = getDataFormatFromExtension(storage, extension);
    storage.builtinHelper._store(assetType, dataFormat, new Uint8Array(buffer), assetId);
};

const preloadSpriteLibraryAssets = async (storage, spriteItem) => {
    const costumeAssets = (spriteItem.costumes || []).map(costume => cacheAsset(storage, costume.md5ext));
    const soundAssets = (spriteItem.sounds || []).map(sound => cacheAsset(storage, sound.md5ext));
    await Promise.all(costumeAssets.concat(soundAssets));
};

const preloadBackdropLibraryAsset = (storage, backdropItem) => cacheAsset(storage, backdropItem.md5ext);

export {
    preloadBackdropLibraryAsset,
    preloadSpriteLibraryAssets
};
